import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";
import { ModelType } from "@/gql/graphql";
import { useOfficeRecord } from "@/app/Offices/Hooks/useOfficeRecord";

export function OfficeActivityScreen() {
  const record = useOfficeRecord();

  return (
    <div className="py-6">
      <RecordScreenCard title={"Activity logs"}>
        <ActivityLogFeed
          modelId={record.id}
          modelType={ModelType.SupplierOffice}
        />
      </RecordScreenCard>
    </div>
  );
}
